<template>
    <div class="prescription-list d-flex flex-column flex-grow-1" style="overflow-x: hidden; overflow-y: auto;">
        <div style="overflow-x: hidden; overflow-y: auto;" class="d-flex flex-column" :class="{
            'card': isEdit
        }">
            <div style="overflow-x: hidden; overflow-y: auto;" class="d-flex flex-column" :class="{
                'card-body': isEdit
            }">
                <div class="mb-1" v-if="isEdit">
                    <!-- <p class="mb-1"><b>Add Medicine</b></p> -->
                    <form data-vv-scope="prescription-add" @submit.prevent="validateMedicine">
                        <div class="form-row">
                            <div class="form-group col">
                                <!-- <label>Medicine Search</label> -->
                                <searchable-dropdown @search="searchDrugList" :options="drugResultList" :isLoading="isLoadingResult" @selected="selectDrugItem" :inputClass="searchInputClass"></searchable-dropdown>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col">
                                <!-- <label>Selected Medicine</label> -->
                                <input name="selectedMedicine" type="text" data-vv-validate-on="blur"
                                    placeholder="Selected Medicine"
                                    data-vv-as="selected medicine" v-validate="'required'" v-model="editing.drugDisplay" readonly :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('prescription-add.selectedMedicine')
                                    }">
                                <!-- <div v-show="validationErrors.has('prescription-add.selectedMedicine')" class="invalid-feedback">
                                    {{ validationErrors.first('prescription-add.selectedMedicine') }}
                                </div> -->
                            </div>
                        </div>
                        <template v-if="drugType===1">
                            <div class="row">
                                <div class="col-5">
                                    <div class="required">
                                        <label>Quantity:</label>
                                        <input :disabled="!editing.drugId" v-model="editing.quantity" name="quantity" type="text" data-vv-validate-on="blur"
                                            data-vv-as="medicine quantity" v-validate="`required|numeric|min_value:1|multiply_of:${editing.minOrderQuantity}`" :class="{
                                            'form-control': true,
                                            'form-control-sm': true,
                                            'is-invalid':  validationErrors.has('prescription-add.quantity'),
                                            'highlight': !!editing.drugDisplay
                                            }">
                                            <div v-show="validationErrors.has('prescription-add.quantity')" class="invalid-feedback">
                                                {{ validationErrors.first('prescription-add.quantity') }}
                                            </div>
                                    </div>
                                </div>
                                <div class="col-7">
                                    <div class="required">
                                        <label>Intake Instruction:</label>
                                        <select name="intake" data-vv-as="intake instruction" :disabled="!editing.drugId" class="form-control form-control-sm" data-vv-validate-on="blur" v-model="editing.intakeInstruction" v-validate="'required'" :class="{
                                            'is-invalid':  validationErrors.has('prescription-add.intake'),
                                            'highlight': !!editing.drugDisplay
                                            }">
                                            <option value="">Select Intake Instruction</option>
                                            <option v-for="(instruction, index) in drugIntakeInstructions" :key="index" :value="instruction.id">
                                                {{ instruction.en }}
                                            </option>
                                        </select>

                                        <div v-show="validationErrors.has('prescription-add.intake')" class="invalid-feedback">
                                            {{ validationErrors.first('prescription-add.intake') }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div id="button" class="mt-2">
                                <a class="btn btn-primary btn-primary-insv" @click="addDrugToList">Add</a>
                            </div>
                        </template>
                        <template v-else>
                            <div class="d-flex">
                                <div class="number-fields d-flex required align-items-baseline">
                                    <label>Quantity:</label>
                                    <input v-model="editing.quantity" name="quantity" type="text" data-vv-validate-on="blur"
                                        data-vv-as="medicine quantity" v-validate="'required|numeric|min_value:1'" :class="{
                                        'form-control': true,
                                        'is-invalid':  validationErrors.has('prescription-add.quantity'),
                                        'highlight': !!editing.drugDisplay
                                        }">
                                    <!-- <div v-show="validationErrors.has('prescription-add.quantity')" class="invalid-feedback">
                                        {{ validationErrors.first('prescription-add.quantity') }}
                                    </div> -->
                                </div>

                                <div class="number-fields d-flex required align-items-baseline">
                                    <label>Frequency (Per day):</label>
                                    <input v-model="editing.consumptionFrequency" name="consumptionFrequency" type="text" data-vv-validate-on="blur"
                                        data-vv-as="medicine consumption frequency" v-validate="'required|numeric|min_value:1'" :class="{
                                        'form-control': true,
                                        'is-invalid':  validationErrors.has('prescription-add.consumptionFrequency'),
                                        'highlight': !!editing.drugDisplay
                                        }">
                                    <!-- <div v-show="validationErrors.has('prescription-add.consumptionFrequency')" class="invalid-feedback">
                                        {{ validationErrors.first('prescription-add.consumptionFrequency') }}
                                    </div> -->
                                </div>

                                <div class="number-fields d-flex required align-items-baseline">
                                    <label>Quantity Per Consumption:</label>
                                    <input v-model="editing.quantityPerConsumption" name="quantityPerConsumption" type="text" data-vv-validate-on="blur"
                                        data-vv-as="medicine quantity per consumption" v-validate="'required|numeric|min_value:1'" :class="{
                                        'form-control': true,
                                        'is-invalid':  validationErrors.has('prescription-add.quantityPerConsumption'),
                                        'highlight': !!editing.drugDisplay
                                        }">
                                    <!-- <div v-show="validationErrors.has('prescription-add.quantityPerConsumption')" class="invalid-feedback">
                                        {{ validationErrors.first('prescription-add.quantityPerConsumption') }}
                                    </div> -->
                                </div>
                                <div id="button" class="ml-auto mr-auto">
                                    <a class="btn btn-primary btn-primary-insv" @click="addDrugToList">Add</a>
                                </div>
                            </div>
                        </template>
                    </form>
                    <!-- <div>
                        <button class="btn btn-primary btn-primary-insv" @click="addDrugToList">Add Medicine</button>
                    </div> -->
                    <hr class="my-2">
                </div>
                <div style="overflow-x: hidden; overflow-y: auto;" id="table-wrapper" class="flex-grow-1 d-flex flex-column">
                    <div class="d-flex justify-content-between align-items-baseline mb-2">
                        <p class="mb-1 mr-2"><b>Medicine List</b></p>
                        <slot></slot>
                    </div>
                    <div v-if="!value || value.length === 0"><span class="font-italic">{{ isEdit ? "No medicine item added yet." : "No medicine prescribed."}}</span></div>
                    <div style="overflow-x: hidden; overflow-y: auto;" class="table-responsive" v-else>
                        <table v-if="drugType===1" class="table">
                            <colgroup>
                            <col>
                            <col width="80">
                            <col width="250">
                            <!-- <col width="80">
                            <col width="100"> -->
                            <col v-if="isEdit" width="100">
                            </colgroup>
                            <tr>
                                <th>Medicine</th>
                                <th class="text-right">Quantity</th>
                                <th>Intake Instruction</th>
                                <!-- <th class="text-right">Frequency</th>
                                <th class="text-right">Per<br>Consumption</th> -->
                                <th v-if="isEdit">Action</th>
                            </tr>
                            <tr v-for="(drug, index) in value" :key="index">
                                <td>
                                    {{drug.productName}} {{drug.drugActiveIngredient ? `(${drug.drugActiveIngredient})` : ''}}
                                </td>
                                <td class="text-right">
                                    {{drug.quantity}}
                                </td>
                                <!-- <td class="text-right">
                                    {{drug.consumptionFrequency}}
                                </td>
                                <td class="text-right">
                                    {{drug.quantityPerConsumption}}
                                </td> -->
                                <td>
                                    {{ getIntakeInstuction(drug.intakeInstruction) ? getIntakeInstuction(drug.intakeInstruction).en : "-" }}
                                </td>
                                <td v-if="isEdit">
                                    <button class="btn btn-danger" type="button" @click="removeDrugFromList(index)">Remove</button>
                                </td>
                            </tr>
                        </table>
                        <table v-if="drugType===2" class="table">
                            <colgroup>
                            <col>
                            <col width="80">
                            <col width="80">
                            <col width="100">
                            <col v-if="isEdit" width="100">
                            <col v-if="isEdit" width="100">
                            </colgroup>
                            <tr>
                                <th>Medicine</th>
                                <th class="text-right">Quantity</th>
                                <th class="text-right">Frequency</th>
                                <th class="text-right">Per<br>Consumption</th>
                                <th v-if="isEdit" class="text-right">Total Price</th>
                                <th v-if="isEdit">Action</th>
                            </tr>
                            <tr v-for="(drug, index) in value" :key="index">
                                <td>
                                    {{drug.productName}} ({{drug.drugActiveIngredient}})
                                </td>
                                <td class="text-right">
                                    {{drug.quantity}}
                                </td>
                                <td class="text-right">
                                    {{drug.consumptionFrequency}}
                                </td>
                                <td class="text-right">
                                    {{drug.quantityPerConsumption}}
                                </td>
                                <td v-if="isEdit" class="text-right">
                                    {{ (drug.quantity*drug.unitPrice).toFixed(2) }}
                                </td>
                                <td v-if="isEdit">
                                    <button class="btn btn-danger" type="button" @click="removeDrugFromList(index)">Remove</button>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <slot name="additional-content"></slot>
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import debounce from 'debounce';
import searchableDropdown from '@/components/searchable-dropdown';
export default {
    'name': 'PrescriptionListModule',
    'components': {
        searchableDropdown
    },
    'props': {
        'isEdit': {
            'type': Boolean,
            'default': false
        },
        'value': {
            'type': Array
        },
        'pharmacyId': {
            'type': String,
            'default': null
        },
        'searchInputClass': {
            'value': String | Object,
            'default': ''
        },
        'drugType': {
            'value': Number,
            'default': 1 // 1 = Legacy -> Drugs Table, 2 = Pharmacy = PharmacyDrugs Table
        }
    },
    'computed': {
        drugUnit () {
            if (this.editing.unit) {
                return `(${this.editing.unit})`;
            }
            return '';
        }
    },
    data () {
        return {
            'selected': null,
            'selectedMedicine': '-',
            'drugResultList': [],
            'isLoadingResult': false,
            'editing': {
                'unit': null,
                'drugId': null,
                'drugDisplay': null,
                'productName': null,
                'drugActiveIngredient': null,
                'drugPrice': 0,
                'quantity': null,
                'consumptionFrequency': null,
                'quantityPerConsumption': null,
                // drug legacy 22/04/2024
                'intakeInstruction': '',
                'minOrderQuantity': 0,
                'unitQuantity': 0

            },
            'searchDrugList': null,
            'drugIntakeInstructions': []
        };
    },
    created () {
        let vm = this;
        this.searchDrugList = debounce((text) => {
            vm.drugResultList = [];

            if (text) {
                vm.isLoadingResult = true;

                if (this.drugType === 1) {
                // call ajax here
                    vm.axios.get('Drugs/SearchDrugs',
                        { 'params': {
                            'searchText': text,
                            'pharmacyId': this.pharmacyId
                        } }).then(({ data }) => {
                        vm.isLoadingResult = false;

                        vm.drugResultList = data.data.map((drug) => ({
                            'value': drug.di,
                            'text': `${drug.pn} ${drug.ai ? `(${drug.ai})` : '-'} [Min Order: ${drug.moq}]`,
                            'drugUnit': drug.u,
                            'productName': drug.pn,
                            'drugActiveIngredient': drug.ai,
                            'unitPrice': drug.up,
                            'minOrderQuantity': drug.moq,
                            'unitQuantity': drug.uq
                        }));
                    });
                } else if (this.drugType === 2) {
                    vm.axios.get('PharmacyDrug/SearchDrugs',
                        { 'params': {
                            'searchText': text
                        } }).then(({ data }) => {
                        vm.isLoadingResult = false;
                        vm.drugResultList = data.data.map((drug) => ({
                            'value': drug.di,
                            'text': `${drug.pn} (${drug.ai}) - Package Size: [${drug.u}]`,
                            'productName': drug.pn,
                            'activeIngredient': drug.ai,
                            'retailPrice': drug.rp,
                            'unit': drug.u
                        }));
                    });
                }
            }
        }, 300);
    },
    mounted () {
        this.$validator.extend(
            'multiply_of', {
                'getMessage': (field, extraParam) => `The Order Quantity must be the multiple of Min Order Quantity (${extraParam})`,
                'validate': (value, extraParam) => {
                    if (value % parseInt(extraParam[0]) === 0) return true;

                    return false;
                }
            });

        this.axios.get('Drugs/GetDrugIntakeInstructions', {
            'params': {
                'pharmacyId': this.pharmacyId
            }
        }).then(({ data }) => {
            this.drugIntakeInstructions = data.data;
        });
    },
    'watch': {
        pharmacyId (val) {
            this.axios.get('Drugs/GetDrugIntakeInstructions', {
                'params': {
                    'pharmacyId': val
                }
            }).then(({ data }) => {
                this.drugIntakeInstructions = data.data;
            });
        }
    },
    'methods': {
        selectDrugItem (drugId) {
            let drug = this.drugResultList.find(d => d.value === drugId);
            if (drug) {
                this.editing.drugId = drug.value;
                this.editing.drugDisplay = drug.text;
                this.editing.productName = drug.productName;
                this.editing.quantity = null;
                this.editing.consumptionFrequency = null;
                this.editing.quantityPerConsumption = null;

                if (this.drugType === 1) {
                    this.editing.drugActiveIngredient = drug.drugActiveIngredient;
                    this.editing.unit = drug.drugUnit;
                    this.editing.unitPrice = drug.unitPrice;
                    this.editing.minOrderQuantity = drug.minOrderQuantity;
                    this.editing.unitQuantity = drug.unitQuantity;
                } else if (this.drugType === 2) {
                    this.editing.drugActiveIngredient = drug.activeIngredient;
                    this.editing.unitPrice = drug.retailPrice;
                }
            }
        },
        validateMedicine () {
            return this.$validator.validateAll('prescription-add');
        },
        addDrugToList () {
            this.$validator.validateAll('prescription-add').then((result) => {
                if (result) {
                    this.value.push({
                        'drugId': this.editing.drugId,
                        'drugDisplay': this.editing.drugDisplay,
                        'unit': this.editing.unit,
                        'productName': this.editing.productName,
                        'drugActiveIngredient': this.editing.drugActiveIngredient,
                        'quantity': this.editing.quantity,
                        'unitPrice': this.editing.unitPrice,
                        'consumptionFrequency': this.editing.consumptionFrequency,
                        'quantityPerConsumption': this.editing.quantityPerConsumption,
                        'intakeInstruction': this.editing.intakeInstruction,
                        'unitQuantity': this.editing.unitQuantity,
                        'minOrderQuantity': this.editing.minOrderQuantity
                    });

                    this.editing.drugId = null;
                    this.editing.drugDisplay = null;
                    this.editing.unit = null;
                    this.editing.productName = null;
                    this.editing.drugActiveIngredient = null;
                    this.editing.quantity = null;
                    this.editing.unitPrice = 0;
                    this.editing.consumptionFrequency = null;
                    this.editing.quantityPerConsumption = null;
                    this.editing.unitQuantity = 0;
                    this.editing.minOrderQuantity = 0;
                    this.editing.intakeInstruction = '';
                }
            });
        },
        removeDrugFromList (index) {
            if (this.value) {
                this.value.splice(index, 1);
            }
        },
        getIntakeInstuction (index) {
            return this.drugIntakeInstructions.find(instruction => instruction.id === index);
        }
    }
};

</script>

<style>
    .overflow-y-only {
        overflow-x: hidden;
        overflow-y: auto;
    }

    .prescription-list {
        font-size: 14px;
    }

    .prescription-list .card {
        border: none;
    }

    .prescription-list .card-body {
        padding: 0;
    }

    .prescription-list input {
        font-size: 14px;
    }

    .prescription-list .number-fields {
        font-size: 11px;
    }
    .prescription-list label {
        margin-right: 2px;
    }

    .prescription-list .number-fields input {
        font-size: 11px;
        width: 40px;
        height: 30px;
        padding: 0 5px 0 5px;
        margin-right: 10px;
        margin-left: 3px;
    }

    .prescription-list #button {
        width: 30px;
        font-size: 11px;
    }

    .prescription-list #button a {
        color: white;
        font-size: 11px;
    }

    .prescription-list .table {
        font-size: 11px;
        height: 100px;
    }

    .prescription-list .table button {
        font-size: 11px;
    }

    .prescription-list .form-group {
        margin-bottom: 5px;
    }

    .prescription-detail .prescription-detail-row .prescription-detail-title {
            margin-bottom: .25rem;
        }

    @media(min-width: 576px) {
        .prescription-detail .prescription-detail-row {
            display: flex;
        }

        .prescription-detail .prescription-detail-row .prescription-detail-title {
            width: 250px;
            margin-bottom: 0;
            margin-right: 1.25rem;
        }

        .prescription-detail .prescription-detail-row .prescription-detail-content {
            display: flex;
            flex: 1;
        }
    }

    .prescription-detail .prescription-detail-row:not(:last-child) {
        margin-bottom: 1.25rem;
    }

    .prescription-detail-content p:last-child {
        margin-bottom: 0;
    }

</style>
